// TODO: add onClick in JSDOCS
import LoadingButton from "@mui/lab/LoadingButton/index";
import { CircularProgress, Menu, Tooltip } from "@mui/material";
import colors from "./colors";
import { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import styles from "./styles";

/**
 *
 * @param {string} 		  				variant    		- either of "text", "contained" or "outlined".
 * @param {string} 		  				buttonText 		- text content of button.
 * @param {object} 			  		  	icon
 * @param {HTMLImageElement}   			icon.startIcon 	- img if icon is at the start.
 * @param {HTMLImageElement}   			icon.endIcon  	- img if icon is at the end.
 * @param {Boolean} 					disabled 		- whether button is disabled or not.
 * @param {Boolean}						isLoading		- disables and shows loading indicator.
 * @param {string}						hierarchy		- "primary" || green ,"destructive" || red or "secondary" || white
 * @returns {import('react').ReactNode}					reusable button component.
 */

export const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#E1E6E2",
    color: "#464D48",
    maxWidth: 220,
    border: "1px solid #dadde9",
    borderRadius: "4px",
  },
  "&.MuiPopperUnstyled-root": {
    zIndex: 1303,
  },
}));

const Button = ({
  variant,
  buttonText,
  icon = { startIcon: null, endIcon: null },
  disabled,
  isLoading,
  hierarchy,
  onClick,
  buttonStyle,
  tooltipMessage,
  styleOverride = {},
  spanStyles = {},
  onSubmit = () => null,
  form = null,
  type = "button",
  className,
  passref = null,
  title = "",
  buttonClassName = "",
}) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const handleMouseInAction = (e) => {
    setTooltipVisible(true);
  };

  const handleMouseOutAction = (e) => {
    setTooltipVisible(false);
  };
  const handleMouseClick = (e) => {
    if (tooltipVisible) setTooltipVisible(false);
    onClick(e);
  };
  return (
    <>
      <StyledTooltip
        placement="top"
        arrow
        open={tooltipVisible && tooltipMessage?.length > 0}
        title={<p className="t7">{tooltipMessage}</p>}
        sx={{
          "& .MuiTooltip-arrow": {
            color: "#E1E6E2",
          },
        }}
      >
        <span className={buttonClassName} style={{ ...spanStyles }}>
          <LoadingButton
            title={title}
            ref={passref}
            variant={variant}
            style={buttonStyle}
            startIcon={icon?.startIcon}
            endIcon={icon?.endIcon}
            disabled={disabled}
            size="large"
            type={type}
            //onClick={e => onClick(e)}
            onClick={handleMouseClick}
            onSubmit={(e) => onSubmit(e)}
            form={form}
            onBlur={(e) => {
              if (tooltipMessage?.length > 0 && !tooltipVisible)
                setTooltipVisible(true);
            }}
            onPointerEnter={handleMouseInAction}
            onPointerLeave={handleMouseOutAction}
            loading={isLoading}
            sx={{
              ...styles.regular_font,

              fontSize:{
                xs: '12px',
                sm: '14px'
              },

              lineHeight:{
                xs: '12px',
                sm: '14px'
              }, 
              
              boxShadow: "none",
              padding: {
                xs: "8px 16px",
                sm: "8px 20px",
                md: "8px 24px",
              },
              color:
                variant === "text"
                  ? colors.ic_green_500
                  : hierarchy === "white"
                    ? colors.nc_gray_900
                    : colors.ic_white,
              borderRadius: "6px",
              // width: '125px', // disabled to set default, 'auto'.
              height: {
                xs: 'max-content',
                sm: "max-content",
                md: "40px",
              },
              backgroundColor:
                hierarchy === "green"
                  ? colors.ic_green_300
                  : hierarchy === "red"
                    ? "#F44336"
                    : "transparent",
              border:
                hierarchy === "white" && variant === "outlined"
                  ? `1px solid ${colors.nc_gray_300}`
                  : "none",
              cursor: isLoading || disabled ? "not-allowed" : "pointer",
              "&:hover, &.Mui-active": {
                border:
                  hierarchy === "white" && variant === "outlined"
                    ? `1px solid ${colors.nc_gray_300}`
                    : "none",
                backgroundColor:
                  hierarchy === "green"
                    ? colors.ic_green_400
                    : hierarchy === "red"
                      ? colors.ic_red_400
                      : colors.nc_gray_100,
                cursor: "pointer",
                boxShadow: "none",
              },
              "&.Mui-disabled, &.Mui-error": {
                color: `#E4E4E7 !important`,
                border: "1px solid #F4F4F5  !important",
                backgroundColor:
                  variant === "text"
                    ? "transparent !important"
                    : `#fafafa !important`,
                pointerEvents: "all",
                cursor: "not-allowed",
              },
              ...styleOverride,
            }}
            className={className}
          >
            {buttonText}
          </LoadingButton>
        </span>
      </StyledTooltip>
    </>
  );
};

export const ViewButton = ({onClick}) => {
  return (
    <button
      className="view-button"
      style={{
        visibility: 'hidden',
        backgroundColor: '#FAFAFA',
        border: '1px solid #E4E4E7',
        borderRadius: '6px',
        padding: '4px 12px',
        fontSize: '14px',
        fontWeight: 500,
        color: '#3F3F46',
        cursor: 'pointer',
        fontFamily: "'Inter', sans-serif",
        lineHeight: '20px',
        whiteSpace: 'nowrap',
        marginLeft: 'auto'
      }}
      onClick={onClick}
    >
      View
    </button>
  )
}

export default Button;
